export default "__VITE_ASSET__0L1iJIDc__"